export const truncateMiddle = (str: string, maxLength: number = 50): string => {
    if (!str || str.length <= maxLength) {
        return str;
    }

    const extension = str.slice(str.lastIndexOf('.'));
    const name = str.slice(0, str.lastIndexOf('.'));
    const availableLength = maxLength - extension.length - 3;

    if (availableLength <= 0) return '...' + extension;

    const halfLength = Math.floor(availableLength / 2);
    return name.slice(0, halfLength) + '...' + name.slice(-halfLength) + extension;
};

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};